import {Button, Modal, Typography} from "antd";
import React from "react";

const {Title} = Typography;


const FinishModal = ({modalVisible, setModalVisible, finishMessage}) => {
    return (
        <Modal
            open={modalVisible}
            closable={false}
            width={600}
            footer={null}
            centered
            styles={{
                mask: {
                    backdropFilter: 'blur(8px)',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)'
                }
            }}
        >
            <div style={{textAlign: 'center'}}>
                <Title level={4}>{finishMessage}</Title>

                <Button
                    type="primary"
                    size="large"
                    style={{marginTop: 24, width: 200}}
                    link
                    onClick={() => {
                        setModalVisible(false);
                        window.location.href = "https://t.me/Tester_uz_Robot";
                    }}
                >
                    Telegramga qaytish
                </Button>
            </div>
        </Modal>
    )
}

export default FinishModal;